import tw from './zh-tw/index.js'
import cn from './zh-cn/index.js'

const messages = {
  'zh-tw' : tw,
  'zh-cn' : cn
}

export default messages
